import React, { useEffect, useState } from 'react';

import debounce from 'lodash.debounce';

import {
    fetchVehicles,
    IVehicle,
    setVehiclesFilter,
} from '@/app/state/app/registers/vehicles';
import {
    useVehicles,
    useVehiclesFilter,
} from '@/app/state/app/registers/index.hooks';
import { showVehicleRFIDDialog } from '@/app/state/ui/dialog';
import Translator from '../../../helpers/TranslationHelper';
import { DEBOUNCE_MID } from '@/app/constants/DebounceValues';
import { useAppDispatch } from '@/app/hooks';
import Pagination from '../../common/Pagination';
import PhraseFilter from '../../common/PhraseFilter';
import VehiclesTable from './VehiclesTable';
import TableWrapper from '../_shared/TableWrapper';
import { useHistory } from 'react-router-dom';
import { RouteVehicleNewPage } from '@/app/pages/paths';
import GroupFilter from '@/app/components/registers/_shared/GroupFilter';

const Vehicles = () => {
    const [currentPage, setCurrentPage] = useState<number>(1);

    const filter = useVehiclesFilter();
    const vehicles = useVehicles();
    const history = useHistory();
    const dispatch = useAppDispatch();

    useEffect(() => {
        dispatch(fetchVehicles(filter));
    }, [filter]);

    const handleGroupChange = (option: { id: string }) => {
        const updatedFilter = {
            ...filter,
            group: option && option.id,
            start: 0,
        };
        setCurrentPage(1);
        dispatch(setVehiclesFilter({ vehiclesFilter: updatedFilter }));
    };

    const handlePageChange = (selectedPageNumber?: number) => {
        const targetPageNumber = selectedPageNumber || currentPage;
        const limit = filter.limit || 1;
        const updatedFilter = {
            ...filter,
            start: (targetPageNumber - 1) * limit,
        };
        setCurrentPage(targetPageNumber);
        dispatch(setVehiclesFilter({ vehiclesFilter: updatedFilter }));
        const element = document.querySelector(
            '#registersPageContent .content'
        );
        element?.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };

    const handleFilterVehicles = debounce((name: string) => {
        const updatedFilter = {
            ...filter,
            name,
            start: 0,
        };
        setCurrentPage(1);
        dispatch(setVehiclesFilter({ vehiclesFilter: updatedFilter }));
    }, DEBOUNCE_MID);

    const handleRFIDDialogClick = (vehicle: IVehicle) => {
        dispatch(showVehicleRFIDDialog({ vehicle }));
    };

    const handleAddVehicleButtonClick = () => {
        history.push(
            RouteVehicleNewPage +
                `?returnUrl=${encodeURIComponent(
                    history.location.pathname + history.location.search
                )}`
        );
    };

    return (
        <section className="vehicles">
            <header className="header">
                <div className="header-filter">
                    <PhraseFilter
                        placeholder={Translator.translate('Find by name') + ' '}
                        onFilter={handleFilterVehicles}
                        filter={filter.name || ''}
                        autoFocus={true}
                        className="header-filter--input"
                    />
                    <GroupFilter
                        name="vehicle-group"
                        selectedOptionId={filter.group}
                        placeholder={Translator.translate('Find by group')}
                        onOptionSelect={handleGroupChange}
                    />
                </div>

                <button
                    className="mtl-button primary"
                    onClick={handleAddVehicleButtonClick}
                >
                    {Translator.translate('New vehicle')}
                </button>
            </header>
            <TableWrapper>
                <VehiclesTable
                    vehicles={vehicles ? vehicles.items : undefined}
                    onAssignRFID={handleRFIDDialogClick}
                />
            </TableWrapper>
            {vehicles && (
                <Pagination
                    totalResults={vehicles.total}
                    currentPage={currentPage}
                    onPageSelect={handlePageChange}
                    resultsPerPage={filter.limit}
                />
            )}
        </section>
    );
};

export default Vehicles;
